module.exports = new __parcel__URL__("motion-background.6277a59a.jpg").toString();